import { useSelector } from 'react-redux';
import management from './management';
import examAdd from './exam-add';
import examList from './exam-list';
import { Roles } from '../constant';
import AuthenticationRoutes from '../../routes/AuthenticationRoutes';
import NotFoundRoutes from '../../routes/NotFoundRoutes';
import clinical from './clinical';

// ==============================|| MENU ITEMS ||============================== //

const MenuItems = () => {
    const account = useSelector((state) => state.accountReducer);
    let sidebar = { items: [] };

    // Get menu items based on service type
    const getMenuItems = () => {
        const role = Roles[account.role];
        if (!role) return [AuthenticationRoutes, NotFoundRoutes];

        // Create a copy of management items to modify
        const managementItems = { ...management };
        const filteredManagementItems = {
            ...managementItems,
            children: managementItems.children.filter((item) => {
                // Hide 라이선스 to roles not related
                return !(item.id === 'license' && role === Roles.COM017_40);
            })
        };

        switch (role) {
            case Roles.COM017_10: // Director or Manager
            case Roles.COM017_20:
                sidebar.items = [examAdd, examList];
                break;
            case Roles.COM017_30: // IT Manager
            case Roles.COM017_60: // Super Administrator
                sidebar.items = [filteredManagementItems];
                break;
            case Roles.COM017_40: // Department Manager
                sidebar.items = [examAdd, examList, filteredManagementItems];
                break;
            case Roles.COM017_50: // Clinical Manager
                sidebar.items = [clinical];
                break;
            default:
                sidebar.items = [];
        }

        return sidebar;
    };

    return getMenuItems();
};

export default MenuItems;
